<template>
  <DashboardPage>
    <PageBreadcrumb :crumbs="[{
      label: $t('auction.auctions')
    }]" />
    <div class="sm:container mx-2 sm:mx-auto md:w-3/4 lg:w-2/3">
      <div class="flex margin-auto mt-4 text-sm shadow border rounded mb-4">
        <button class="font-bold py-2 px-1 rounded-l w-1/3 flex items-center justify-start flex-col" :class="{
          'bg-corepla-bg-light': statusFilter !== 'OPEN',
          'hover:bg-corepla-bg-dark': statusFilter !== 'OPEN',
          'hover:text-white': statusFilter !== 'OPEN',
          'bg-corepla-bg-dark': statusFilter === 'OPEN',
          'text-white': statusFilter === 'OPEN'
        }" @click="statusFilter = 'OPEN'">
          <div>
            <BellAlertIcon class="h-4 w-4 mr-1 inline-block" />
          </div>
          <div>{{ $t("auction.open") }}</div>
        </button>
        <button class="font-bold py-2 px-1 w-1/3 flex items-center justify-start flex-col" :class="{
          'bg-corepla-bg-light': statusFilter !== 'PUBLISHED',
          'hover:bg-corepla-bg-dark': statusFilter !== 'PUBLISHED',
          'hover:text-white': statusFilter !== 'PUBLISHED',
          'bg-corepla-bg-dark': statusFilter === 'PUBLISHED',
          'text-white': statusFilter === 'PUBLISHED'
        }" @click="statusFilter = 'PUBLISHED'">
          <div>
            <BellIcon class="h-4 w-4 mr-1 inline-block" />
          </div>
          <div>{{ $t("auction.published") }}</div>
        </button>
        <button class="font-bold py-2 px-1 w-1/3 flex items-center justify-start flex-col" :class="{
          'bg-corepla-bg-light': statusFilter !== 'REDISTRIBUTING_1',
          'hover:bg-corepla-bg-dark': statusFilter !== 'REDISTRIBUTING_1',
          'hover:text-white': statusFilter !== 'REDISTRIBUTING_1',
          'bg-corepla-bg-dark': statusFilter === 'REDISTRIBUTING_1',
          'text-white': statusFilter === 'REDISTRIBUTING_1'
        }" @click="statusFilter = 'REDISTRIBUTING_1'">
          <div>
            <BellSnoozeIcon class="h-4 w-4 mr-1 inline-block" />
          </div>
          <div>{{ $t("auction.redistributing") }}</div>
          <div class="text-xs">
            (fase 1)
          </div>
        </button>
        <button class="font-bold py-2 px-1 w-1/3 flex items-center justify-start flex-col" :class="{
          'bg-corepla-bg-light': statusFilter !== 'REDISTRIBUTING_2',
          'hover:bg-corepla-bg-dark': statusFilter !== 'REDISTRIBUTING_2',
          'hover:text-white': statusFilter !== 'REDISTRIBUTING_2',
          'bg-corepla-bg-dark': statusFilter === 'REDISTRIBUTING_2',
          'text-white': statusFilter === 'REDISTRIBUTING_2'
        }" @click="statusFilter = 'REDISTRIBUTING_2'">
          <div>
            <BellSnoozeIcon class="h-4 w-4 mr-1 inline-block" />
          </div>
          <div>{{ $t("auction.redistributing") }}</div>
          <div class="text-xs">
            (fase 2)
          </div>
        </button>
        <button class="font-bold py-2 px-1 rounded-r w-1/3 flex items-center justify-start flex-col" :class="{
          'bg-corepla-bg-light': statusFilter !== 'CLOSED',
          'hover:bg-corepla-bg-dark': statusFilter !== 'CLOSED',
          'hover:text-white': statusFilter !== 'CLOSED',
          'bg-corepla-bg-dark': statusFilter === 'CLOSED',
          'text-white': statusFilter === 'CLOSED'
        }" @click="statusFilter = 'CLOSED'">
          <div>
            <BellSlashIcon class="h-4 w-4 mr-1 inline-block" />
          </div>
          <div>{{ $t("auction.closed") }}</div>
        </button>
      </div>
    </div>

    <SpinningLoader :pending="pending">
      <div class="sm:container mx-2 sm:mx-auto">
        <div v-if="auctions.length">
          <div v-for="auction in auctions" :key="'auctions-view-' + auction.uuid">
            <AuctionItem :withAttachment="false"
              v-if="auction.auctionStatus !== 'CLOSED' || auction.auctionCloseReason === 'COMPLETED'"
              :key="'auction-item-' + auction.uuid" :auction="auction" />
          </div>
        </div>
        <div v-else class="text-center font-bold mt-6">
          {{ $t("auction.not_available") }}
        </div>
      </div>
    </SpinningLoader>
  </DashboardPage>
</template>

<script setup>
import { BellAlertIcon, BellIcon, BellSlashIcon, BellSnoozeIcon } from '@heroicons/vue/24/solid';
import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'

import DashboardPage from '@/components/DashboardPage.vue';
import useAxios from '@/composables/axios';
import sse from '@/services/sse';

import AuctionItem from '../components/AuctionItem.vue';
import PageBreadcrumb from '../components/PageBreadcrumb.vue';
import SpinningLoader from '../components/SpinningLoader.vue';

const pending = ref(true)
const statusFilter = ref('OPEN')

const axios = useAxios()
const { t } = useI18n()
const auctions = ref([]);

const refreshAuctions = function () {
  pending.value = true;
  axios.get('/auction/list?auctionStatuses=' + statusFilter.value).then((resp) => {
    auctions.value = resp.data
    pending.value = false;
  }).catch(() => {
    
  });
}

watch(statusFilter, refreshAuctions);
refreshAuctions();

sse.addListener('AUCTION_OPENED', data => {
  refreshAuctions();
  //pushInfo(t('notifications.new_auction_available'));
});

sse.addListener('AUCTION_CLOSED', data => {
  refreshAuctions();
});

sse.addListener('AUCTION_REDISTRIBUTING', data => {
  refreshAuctions();
});
</script>